import { SpcSamplingMethod } from "src/components/views/spc/masterData/controlCharts/form/samplingMethod/SpcSamplingMethod.tsx";

export const getCurrentTimeSamplingMethod = (): SpcSamplingMethod => {
	return {
		key: "dev_method_2",
		label: "Dev method (current time)",
		renderParameterFields: () => <></>,
	};
};
